import { Box, Button, Card, Typography } from "@material-ui/core";
import { differenceInCalendarDays } from "date-fns";
import React, { useEffect, useState } from "react";
import Avatar from "react-avatar";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { startLoading, stopLoading } from "../../../actions/loadingAction";
import { errorSnackbar } from "../../../actions/snackbarActions";
import { Endpoint, Status } from "../../../apis/apiConstants";
import AjaxHelper from "../../../apis/apiRequest";
import "./viewAwards.scss";

const Awards = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [awardPages, setAwardPages] = useState(0);
  const [awards, setAwards] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  let prevScrollTop = 0;

  useEffect(() => {
    getAwardsData();

    const handleScroll = () => {
      // Calculate the scroll position
      const scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      const scrollHeight =
        document.documentElement.scrollHeight || document.body.scrollHeight;
      const clientHeight =
        document.documentElement.clientHeight || document.body.clientHeight;

      const currentScrollTop =
        window.scrollY || document.documentElement.scrollTop;
      if (scrollTop + clientHeight >= scrollHeight - 10) {
        if (currentScrollTop > prevScrollTop) {
          const nextPage = currentPage + 1;
          console.log(nextPage);
          if (nextPage <= awardPages) {
            setCurrentPage(nextPage);
            getAwards(nextPage);
          }
        }
      }
      prevScrollTop = currentScrollTop;
    };

    // Attach the event listener to the window
    window.addEventListener("scroll", handleScroll);

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const markVote = (awardId, participantId) => {
    dispatch(startLoading);
    AjaxHelper.postApi(navigate, Endpoint.ADD_AWARD_VOTE, {
      awardId,
      participantId,
    })
      .then((response) => {
        dispatch(stopLoading);
        if (response.data.status === Status.API_SUCCESS) {
          getAwardsData();
        } else if (response.data.status === Status.API_NO_CONTENT) {
          dispatch(errorSnackbar(response.data.message));
        } else {
          dispatch(errorSnackbar(response.data.message));
        }
      })
      .catch((err) => {
        dispatch(stopLoading);
        dispatch(errorSnackbar("Error while voting."));
      });
  };

  const getParticipants = (award) => {
    return award.participants.map((user) => {
      return (
        <div className="d-flex align-items-center" style={{ gap: 8 }}>
          <div
            className="getParticipantsVote"
            style={{
              backgroundColor:
                award.voteFor && user._id === award.voteFor
                  ? "#d9ead3"
                  : "white",
            }}
          >
            <Avatar
              name={`${user.firstName} ${user.lastName}`}
              round={true}
              size={44}
            />
            <div>
              <div
                className={"appFontMedium"}
              >{`${user.firstName} ${user.lastName}`}</div>
              <div className={"appFont"}>{user.userCode}</div>
            </div>
          </div>
          {award.daysLeftToExpire > 0 && !award.voteFor ? (
            <Button
              variant="contained"
              className="getParticipantsVoteFor"
              onClick={() => markVote(award._id, user._id)}
            >
              Vote
            </Button>
          ) : null}
        </div>
      );
    });
  };

  const getAwards = (page) => {
    dispatch(startLoading);
    AjaxHelper.getApi(navigate, Endpoint.GET_AWARDS_USER, {}, { page })
      .then((response) => {
        dispatch(stopLoading);
        if (response.data.status === Status.API_SUCCESS) {
          console.log(response.data.data);
          let a = response.data.data;
          a = a.map((x) => {
            return {
              ...x,
              daysLeftToExpire: differenceInCalendarDays(
                new Date(x.expireDate),
                Date.now()
              ),
            };
          });
          setAwards(a);
        } else if (response.data.status === Status.API_NO_CONTENT) {
          dispatch(errorSnackbar(response.data.message));
        } else {
          dispatch(errorSnackbar("Error while fetching Awards."));
        }
      })
      .catch((err) => {
        dispatch(stopLoading);
        dispatch(errorSnackbar("Error while fetching Awards."));
      });
  };

  const getAwardsCount = () => {
    AjaxHelper.getApi(navigate, Endpoint.GET_AWARDS_PAGES)
      .then((response) => {
        if (response.data.status === Status.API_SUCCESS) {
          setAwardPages(response.data.data.pages);
        }
      })
      .catch((error) => {
        // dispatch(errorFetchApplicants);
      });
  };

  const getAwardsData = () => {
    getAwards(currentPage);
    getAwardsCount();
  };

  return (
    <Box className="viewAwards">
      {awards.map((award) => (
        <>
          <Card className="ViewAwardCard">
            <>
              <Typography className="viewAwardTitle">
                {award.title}
                <Typography className={"appFont"}>
                  {award.description}
                </Typography>

                <Typography className="votingValidity">
                  {award.daysLeftToExpire > 0
                    ? `Voting open for ${award.daysLeftToExpire} days`
                    : null}
                </Typography>
              </Typography>
              <div
                className={
                  "d-flex flex-column justify-content-start align-items-start"
                }
                style={{ paddingLeft: "3%", paddingRight: "3%" }}
              >
                {getParticipants(award)}
              </div>
            </>
          </Card>
        </>
      ))}
    </Box>
  );
};

export default Awards;
